<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <header class="c-toolbar" v-if="!loading">
        <div class="l-level">
          <div class="l-level__left">
            <img v-if="fromModuleDefinition !== null" :src="fromModuleDefinition.logo" class="logo" alt="">
            <i class="i-arrow icon-arrow-right"></i>
            <img v-if="fromModuleDefinition !== null" :src="toModuleDefinition.logo" class="logo" alt="">
            <h1 class="c-toolbar__title title">Editar produto</h1>
          </div>
        </div>
      </header>

      <div v-if="product">
        <component :is="productEditComponent" ref="marketplaceEditProduct" :product="product"/>
      </div>

      <panel>
        <button class="btn btn--success" @click="save">{{ $t('save.label') }}</button>
      </panel>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import { upperFirst } from 'lodash'
  import notifier from '@/notifier'
  import Loader from '@/components/template/Loader'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import PageTitle from '@/components/template/PageTitle'
  import ProductEditSkyhub from '@/components/marketplace/skyhub/ProductEdit'
  import ProductEditShopee from '@/components/marketplace/shopee/ProductEdit'
  import ProductEditTikTokShop from '@/components/marketplace/tiktokshop/ProductEdit.vue'
  import ProductEditShein from '@/components/marketplace/shein/ProductEdit.vue'
  import ProductEditNetshoes from '@/components/marketplace/netshoes/ProductEdit'
  import ProductEditLeroy from '@/components/marketplace/leroy/ProductEdit'
  import ProductEditIntegracommerce from '@/components/marketplace/integracommerce/ProductEdit'
  import ProductEditColombo from '@/components/marketplace/colombo/ProductEdit'
  import ProductEditCnova from '@/components/marketplace/cnova/ProductEdit'
  import ProductEditCarrefour from '@/components/marketplace/carrefour/ProductEdit'
  import ProductEditWebcontinental from '@/components/marketplace/webcontinental/ProductEdit'
  import ProductEditMadeira from '@/components/marketplace/madeira/ProductEdit'
  import ProductEditGfg from '@/components/marketplace/gfg/ProductEdit'
  import ProductEditZoom from '@/components/marketplace/zoom/ProductEdit'
  import ProductEditCentauro from '@/components/marketplace/centauro/ProductEdit'
  import ProductEditAmazon from '@/components/marketplace/amazon/ProductEdit'
  import ProductEditRicardoEletro from '@/components/marketplace/ricardoEletro/ProductEdit'
  import ProductEditRenner from '@/components/marketplace/renner/ProductEdit'
  import ProductEditConectaLa from '@/components/marketplace/conectaLa/ProductEdit'
  import ProductEditPolishop from '@/components/marketplace/polishop/ProductEdit'
  import ProductEditSicoob from '@/components/marketplace/sicoob/ProductEdit'
  import ProductEditDecathlon from '@/components/marketplace/decathlon/ProductEdit'
  import ProductEditKeepRunning from '@/components/marketplace/keepRunning/ProductEdit'
  import ProductEditRamarim from '@/components/marketplace/ramarim/ProductEdit'
  import ProductEditComfortflex from '@/components/marketplace/comfortflex/ProductEdit'
  import ProductEditSicredi from '@/components/marketplace/sicredi/ProductEdit'
  import ProductEditMagalu from '@/components/marketplace/magalu/ProductEdit'
  import ProductEditMaisCorreios from '@/components/marketplace/maisCorreios/ProductEdit'

  export default {
    data: () => ({
      loading: true,
      product: null
    }),
    props: {
      identifier: {
        type: String,
        required: true
      },
      sku: {
        type: String,
        required: true
      }
    },
    async created () {
      this.clearErrors()

      this.product = this.getBySku(this.sku)
      if (!this.product) {
        await this.addItem({type: 'marketplace', identifier: this.identifier, id: this.sku})
        this.product = this.getBySku(this.sku)

        if (this.product === undefined) {
          this.$router.push(`/marketplace/${this.identifier}/products`)
          this.loading = false

          return
        }
      }

      if (this.product.status !== 'approved' && this.identifier !== 'cnova') {
        notifier.error('Não é permitido a edição de produtos que não estão aprovados', 'Falha')
        this.$router.push(`/marketplace/${this.identifier}/products`)
      }

      this.loading = false
    },
    methods: {
      ...mapActions('productsMarketplace', [
        'addItem'
      ]),
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      async save () {
        if (this.identifier === 'cnova') {
          let hasError = false

          if (this.product.height < 0.01 || this.product.height > 7.0) {
            hasError = true
            this.addError({
              productId: this.product.productId,
              property: `product.height`,
              error: {
                message: 'height',
                value: 1
              }
            })
          }

          if (this.product.width < 0.01 || this.product.width > 7.0) {
            hasError = true
            this.addError({
              productId: this.product.productId,
              property: `product.width`,
              error: {
                message: 'width',
                value: 1
              }
            })
          }

          if (this.product.length < 0.01 || this.product.length > 7.0) {
            hasError = true
            this.addError({
              productId: this.product.productId,
              property: `product.length`,
              error: {
                message: 'length',
                value: 1
              }
            })
          }

          if (hasError) {
            return
          }
        }
        this.clearErrors()
        this.loading = true

        const formattedProduct = this.$refs.marketplaceEditProduct.$children[0].formatProduct()

        try {
          this.product = await api.updateProduct('marketplace', this.identifier, formattedProduct)
          notifier.success('Produto atualizado com sucesso', 'Atualizado')
          this.loading = false
        } catch (error) {
          notifier.error(error.response.data.message, 'Falha')
          this.loading = false
        }
      }
    },
    computed: {
      ...mapGetters('productsMarketplace', [
        'getBySku'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      toModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', this.identifier)
      },
      fromModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType(this.product.source.type, this.product.source.identifier)
      },
      productEditComponent () {
        return `ProductEdit${upperFirst(this.identifier)}`
      }
    },
    components: {
      PageTitle,
      Loader,
      Panel,
      FormGroup,
      ProductEditShopee,
      ProductEditTikTokShop,
      ProductEditShein,
      ProductEditSkyhub,
      ProductEditNetshoes,
      ProductEditLeroy,
      ProductEditIntegracommerce,
      ProductEditColombo,
      ProductEditCnova,
      ProductEditCarrefour,
      ProductEditWebcontinental,
      ProductEditMadeira,
      ProductEditZoom,
      ProductEditGfg,
      ProductEditCentauro,
      ProductEditAmazon,
      ProductEditRicardoEletro,
      ProductEditRenner,
      ProductEditConectaLa,
      ProductEditPolishop,
      ProductEditSicoob,
      ProductEditDecathlon,
      ProductEditKeepRunning,
      ProductEditRamarim,
      ProductEditComfortflex,
      ProductEditSicredi,
      ProductEditMagalu,
      ProductEditMaisCorreios
    }
  }
</script>

<style lang="sass" scoped>
  .logo
    max-height: 30px

  .title
    margin-left: 20px

  .i-arrow
    font-size: 20px
    margin: 0 20px
</style>



// WEBPACK FOOTER //
// Edit.vue?6580d2e3